import { AwardMeta } from './meta/fw/AwardMeta';
import { ContractMeta } from './meta/fw/ContractMeta';
import { EquipmentMeta } from './meta/fw/EquipmentMeta';
import { EventMeta } from './meta/fw/EventMeta';
import { PRMeta } from './meta/fw/PRMeta';
import { getAwardVerbose } from './verbose/fw/AwardVerbose';
import { getContractVerbose } from './verbose/fw/ContractVerbose';
import { getEquipmentVerbose } from './verbose/fw/EquipmentVerbose';
import { getEventVerbose } from './verbose/fw/EventVerbose';
import { getPRVerbose } from './verbose/fw/PRVerbose';

const AwardVerbose = getAwardVerbose(AwardMeta);
const ContractVerbose = getContractVerbose(ContractMeta);
const EquipmentVerbose = getEquipmentVerbose(EquipmentMeta);
const EventVerbose = getEventVerbose(EventMeta);
const PRVerbose = getPRVerbose(PRMeta);

const a = AwardMeta.length; // 17
const b = a + ContractMeta.length; // 14
const c = b + PRMeta.length; // 12
const d = c + EquipmentMeta.length; // 11
const e = d + EventMeta.length; // 16

// COMMENTED NUMBER RANGE IS THE ARRAY INDECES
export function getCardFromFallWinterDeckById(cardId: number) {
	let card: any;
	if (cardId < a) {
		card = AwardMeta[cardId]; // 0 - 16
	} else if (cardId < b) {
		card = ContractMeta[cardId - a]; // 17 - 20
	} else if (cardId < c) {
		card = PRMeta[cardId - b]; // 21 - 32
	} else if (cardId < d) {
		card = EquipmentMeta[cardId - c]; // 33 - 43
	} else if (cardId < e) {
		card = EventMeta[cardId - d]; // 44 - 69
	}

	return card;
}

// const a = AwardVerbose.length; // 17
// const b = a + ContractVerbose.length; // 14
// const c = b + PRVerbose.length; // 12
// const d = c + EquipmentVerbose.length; // 11
// const e = d + EventVerbose.length; // 16

// COMMENTED NUMBER RANGE IS THE ARRAY INDECES
export function getCardVerboseFromFallWinterDeckById(cardId: number) {
	let card;
	if (cardId < a) {
		card = AwardVerbose[cardId]; // 0 - 16
	} else if (cardId < b) {
		card = ContractVerbose[cardId - a]; // 17 - 20
	} else if (cardId < c) {
		card = PRVerbose[cardId - b]; // 21 - 32
	} else if (cardId < d) {
		card = EquipmentVerbose[cardId - c]; // 33 - 43
	} else if (cardId < e) {
		card = EventVerbose[cardId - d]; // 44 - 69
	}

	return card;
}
